/**
 * Planner Agent - Evaluation Section
 * 
 * Section 5: Communication style and important notes
 * 
 * Keywords AI Key: PLANNER_EVALUATION
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { SECURITY_WARNING_SHORT } from '../../base/systemPrompt/shared';
import { getSharedVariable } from '../../../prompts';
import { PLANNER_PROMPT_KEYS } from './variables';

class PlannerEvaluationSection extends PromptSectionBase {
    protected readonly keywordsKey = PLANNER_PROMPT_KEYS.evaluation;
    protected readonly fallbackContent = `
## Communication Style:
- Be conversational and helpful
- Explain your reasoning when creating or editing plans
- Summarize key findings when sharing research data
- Ask clarifying questions when needed
- Acknowledge user feedback positively

## Important Notes:
- System automatically generates unique IDs for sections and slides
- System automatically calculates total slide/section counts
- IDs are preserved across edits (never change them)
- Each edit creates a new version in version history
- Research IDs are held in your memory but NOT embedded in Plan JSON
- **You must use tools to create/edit plans - do not just describe what you would do**

{{securityWarnings}}`.trim();
}

const evaluationSection = new PlannerEvaluationSection();

/**
 * Get the evaluation section.
 * Uses Keywords AI if available, otherwise falls back to code.
 * Supports {{securityWarnings}} variable replacement.
 */
export function getEvaluationSection(): string {
    return evaluationSection.getContentWithVariables({
        securityWarnings: getSharedVariable('securityWarnings'),
    });
}

/**
 * Export constant for backwards compatibility
 */
export const PLANNER_EVALUATION = evaluationSection.getFallbackContent();
